<template>
  <div>
    <nav class="navbar navbar-expand-md navbar-dark bg-dark">
      <div class="container-fluid p-md-0 ps-md-1">
        <nuxt-link class="navbar-brand" to="/">
          <svg
            height="34px"
            viewBox="0 0 90 112"
            x="0px"
            xmlns="http://www.w3.org/2000/svg"
            y="0px"
          >
            <g>
              <path
                d="M72.42,43.31c-6.72-7.21-15.99-11.17-26.1-11.17h-0.7c-3.36,0-6.96,2.74-6.96,6.82
                c0,4.03,2.93,6.96,6.96,6.96c13.42,0,22.44,11.67,22.44,22.57c0,10.86-8.63,22.58-22.58,22.58c-17.17,0-27.77-8.73-35.09-16.55
                v14.48c6.54,6.79,18.07,14.87,35.93,15.01c19.81,0,35.93-16.12,35.93-35.93C82.25,59.03,78.67,50.01,72.42,43.31z"
                fill="#FFFFFF"
              />
              <path
                d="M7.75,39.93c0,9.09,3.58,18.13,9.83,24.81c6.71,7.17,15.98,11.12,26.1,11.12h0.7c3.29,0,6.96-2.8,6.96-6.82
                c0-3.97-2.99-6.96-6.96-6.96c-13.42,0-22.44-11.67-22.44-22.57c0-10.86,8.63-22.57,22.57-22.57c11.3,0,20.84,3.7,29.94,11.63V14.44
                C65.85,7.63,55.49,4.12,43.67,4C23.86,4,7.75,20.12,7.75,39.93z"
                fill="#FFFFFF"
              />
            </g>
          </svg>
        </nuxt-link>
      </div>
    </nav>
    <div class="my-3">
      <NuxtPage />
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Empty',
  }
</script>

<style scoped>
  .navbar-expand-md {
    height: 42px;
  }

  @media only screen and (max-width: 768px) {
    .navbar-expand-md {
      height: revert;
    }
  }
</style>
